import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { loadingSkeletonStyle } from '../../css/style';

const skeletonStyles = loadingSkeletonStyle();

const ChartSkeleton = ({
  outerContainerStyle,
  oneLineStyle,
  circle,
  height,
  count,
  width,
}) => (
  <div style={outerContainerStyle || skeletonStyles.fullWidthWrapperToEnsureShowsUp}>
    <Skeleton
      count={count || 9}
      style={oneLineStyle || skeletonStyles.chartSkeletonLineSpacer}
      circle={circle}
      height={height || null}
      width={width || null}
    />
  </div>
);

export default ChartSkeleton;
